'use strict'
import AdministrationAction from 'administration/actions/AdministrationAction'
import { FileIconMUI } from 'components/styled/Buttons'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import DtoPublicPicture from 'station/dto/DtoPublicPicture'
import AppStore from 'store/AppStore'
import ToastrAction from 'toastr/actions/ToastrAction'
import ActionComponent from '../../../components/ActionComponent'
import Card from '../../../components/card/Card'
import Input from '../../../components/forms/Input'
import Select from '../../../components/forms/Select'
import SieauAction from '../../../components/sieau/SieauAction'
import HomeAction from '../../../home/actions/HomeAction'
import CityDto from '../../../referencial/components/city/dto/CityDto'
import ContactDto from '../../../referencial/components/contact/dto/ContactDto'
import { getLogin } from '../../../utils/SettingUtils'
import { Grid } from '@mui/material'
import User from '../../dto/User'

class UpdateUserForm extends ActionComponent {
    constructor(props) {
        super(props)
        this.state = {
            pictureUrl: '',
        }
    }

    componentWillMount() {
        AppStore.dispatch(SieauAction.forceFetch('title', [{
            title: i18n.myAccount,
            href: 'account',
        }]))
    }

    componentDidMount() {
        this.setPictureUrl()
    }

    componentDidUpdate(prevProps) {
        const { profileLoginPicture, profilePicture } = this.props
        if (prevProps.profileLoginPicture.updateDate !== profileLoginPicture.updateDate || prevProps.profilePicture !== profilePicture) {
            this.setPictureUrl()
        }
    }

    setPictureUrl = () => {
        const { profileLoginPicture, profilePicture } = this.props
        if (profilePicture && profilePicture.content) {
            this.setState({ pictureUrl: profilePicture.content })
        } else if (profileLoginPicture.name) {
            this.props.fetchPictureWithoutCache(profileLoginPicture.name).then((url) => {
                this.setState({ pictureUrl: url })
            })
        }
    }

    resetPassword = () => {
        if (!this.props.contact || !this.props.contact.email) {
            AppStore.dispatch(ToastrAction.error(i18n.noEmailWithLogin))
        } else {
            AppStore.dispatch(HomeAction.resetPassword(this.props.accountUser.login, false))
        }
    }

    changeCity = (value) => {
        this.props.changeContactValue('cityCode', value)
    }

    onUploadFile = (event) => {
        // Read File
        if (event.target.files && event.target.files[0]) {
            let reader = new FileReader()
            const file = event.target.files[0]
            const name = `${getLogin()}${file.name.substring(file.name.lastIndexOf('.'), file.name.length)}`
            reader.onload = (e) => {
                this.props.changePictureToUpdate({
                    profilePicture:
                    {
                        name,
                        content: e.target.result,
                    },
                })
            }
            reader.readAsDataURL(event.target.files[0])
        }
    }

    getPicture = () => {
        const { pictureUrl } = this.state
        if (pictureUrl.length > 0) {
            return (
                <img
                    id='profile_picture'
                    src={pictureUrl}
                    className='circle'
                    style={{ height: '15em', width: '15em', objectFit: 'cover' }}
                />
            )
        }
        return (
            <i className='material-icons hugeProfilePicture responsive-img row'>account_circle</i>
        )
    }

    render() {
        if (this.props.contact) {
            return (
                <>
                    <Card>
                        <Grid container sx={{ paddingTop: '1em' }}>
                            <Grid size={9}>
                                <Grid container spacing={1}>
                                    <Grid size={6}>
                                        <Input title={ i18n.name } value={ this.props.contact.name }
                                            onChange={ (e) => this.props.changeContactValue('name', e) }
                                        />
                                    </Grid>
                                    <Grid size={6}>
                                        <Input title={ i18n.email } value={ this.props.contact.email }
                                            onChange={ (e) => this.props.changeContactValue('email', e) }
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid size={12}>
                                        <Input title={ i18n.address } value={ this.props.contact.address }
                                            onChange={ (e) => this.props.changeContactValue('address', e) }
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1}>
                                    <Grid size={6}>
                                        <Input title={ i18n.postcode } value={ this.props.contact.postalBox } maxLength={ 5 }
                                            onChange={ (e) => this.props.changeContactValue('postalBox', e) }
                                        />
                                    </Grid>
                                    <Grid size={6}>
                                        <Select options={ this.props.cities }
                                            label={ i18n.city }
                                            displayWithCode
                                            onChange={ this.changeCity }
                                            value={ this.props.contact.cityCode }
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1}>
                                    <Grid size={6}>
                                        <Input title={ i18n.mobile } value={ this.props.contact.mobile }
                                            onChange={ (e) => this.props.changeContactValue('mobile', e) }
                                        />
                                    </Grid>
                                    <Grid size={6}>
                                        <Input title={ i18n.phoneTel } value={ this.props.contact.phoneTel }
                                            onChange={ (e) => this.props.changeContactValue('phoneTel', e) }
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid size={6}>
                                        <Input title={ i18n.desktopTel } value={ this.props.contact.desktopTel }
                                            onChange={ (e) => this.props.changeContactValue('desktopTel', e) }
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid size={3}>
                                <Grid container>
                                    <Grid size={12} sx={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        {this.getPicture()}
                                        <FileIconMUI
                                            tooltip={i18n.changePicture}
                                            onChange={this.onUploadFile}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Card>
                    <div className='padding-top-1' />
                    <Card>
                        <Grid container sx={{ paddingBottom: 1 }}>
                            <Grid size={8} sx={{ paddingTop: 1, paddingLeft: 2 }}>
                                <h6 className='right-align'>{ i18n.willReceiveConfirmationEmail }</h6>
                            </Grid>
                            <Grid size={4} sx={{ paddingRight: 1 }}>
                                <a className='waves-effect waves-light btn margin-top-1 margin-left-1 right'
                                    onClick={ () => this.resetPassword() }
                                >
                                    { i18n.passwordReset }
                                </a>
                            </Grid>
                        </Grid>
                    </Card>
                </>
            )
        }
        return null
    }
}

UpdateUserForm.propTypes = {
    contact: PropTypes.instanceOf(ContactDto),
    contacts: PropTypes.arrayOf(PropTypes.instanceOf(ContactDto)),
    cities: PropTypes.arrayOf(PropTypes.instanceOf(CityDto)),
    changeContactValue: PropTypes.func,
    accountUser: PropTypes.instanceOf(User),
    profileLoginPicture: PropTypes.instanceOf(DtoPublicPicture),
    profilePicture: PropTypes.shape({
        name: PropTypes.string,
        content: PropTypes.string,
    }),
    changePictureToUpdate: PropTypes.func,
    fetchPictureWithoutCache: PropTypes.func,
}
const mapStateToProps = (store) => {
    return {
        contacts: store.ContactReducer.contacts,
        cities: store.CityReducer.cities,
        accountUser: store.AccountReducer.accountUser,
        profileLoginPicture: store.AdministrationReducer.profileLoginPicture,
    }
}

const mapDispatchToProps = {
    fetchPictureWithoutCache: AdministrationAction.fetchPictureWithoutCache,
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdateUserForm)
